import {
  GET_DEPARTMENTS,
  GET_DEPARTMENTS_FAIL,
  GET_DEPARTMENTS_SUCCESS,
  ADD_NEW_DEPARTMENT,
  ADD_DEPARTMENT_SUCCESS,
  ADD_DEPARTMENT_FAIL,
  UPDATE_DEPARTMENT,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAIL,
  DELETE_DEPARTMENT,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAIL,
  
} from "./actionTypes";

export const getDepartments = () => ({
  type: GET_DEPARTMENTS,
})

export const getDepartmentsSuccess = departments => ({
  type: GET_DEPARTMENTS_SUCCESS,
  payload: departments,
})

export const getDepartmentsFail = error => ({
  type: GET_DEPARTMENTS_FAIL,
  payload: error,
})

export const addNewDepartment = data => ({
  type: ADD_NEW_DEPARTMENT,
  payload: data,
})

export const addDepartmentSuccess = department => ({
  type: ADD_DEPARTMENT_SUCCESS,
  payload: department,
})

export const addDepartmentFail = error => ({
  type: ADD_DEPARTMENT_FAIL,
  payload: error,
})

export const updateDepartment = department => ({
  type: UPDATE_DEPARTMENT,
  payload: department,
})

export const updateDepartmentSuccess = department => ({
  type: UPDATE_DEPARTMENT_SUCCESS,
  payload: department,
})

export const updateDepartmentFail = error => ({
  type: UPDATE_DEPARTMENT_FAIL,
  payload: error,
})

export const deleteDepartment = data => ({
  type: DELETE_DEPARTMENT,
  payload: data,
})

export const deleteDepartmentSuccess = data => ({
  type: DELETE_DEPARTMENT_SUCCESS,
  payload: data,
})

export const deleteDepartmentFail = error => ({
  type: DELETE_DEPARTMENT_FAIL,
  payload: error,
})

